import React from 'react';

const TermsAndConditions = () => {
  return (
    <section className="bg-white py-12 px-6 max-w-4xl mx-auto text-gray-800">
      <h1 className="text-3xl font-bold mb-6 mt-8">Terms and Conditions</h1>

      <p className="mb-4">Welcome to Racila Softech Pvt. Ltd. ("Company," "we," "our," "us"). These Terms and Conditions govern your use of our website, products, and services. By accessing or using our services, you agree to these Terms. If you do not agree, please stop using our services.</p>

      <h2 className="text-xl font-semibold mt-6 mb-2">1. Provided Services</h2>
      <ul className="list-disc list-inside ml-4 mb-4">
        <li>Website and application development</li>
        <li>Domain registration and hosting solutions</li>
        <li>Mobile-first website development</li>
        <li>AI/ML development and business automation</li>
        <li>Training and internship programs</li>
        <li>Custom software solutions</li>
        <li>Consultancy services to provide skilled employees as needed</li>
      </ul>

      <h2 className="text-xl font-semibold mt-6 mb-2">2. Eligibility</h2>
      <p className="mb-4">Customers must be at least 18 years old or a legally registered business entity. Those under 18 may participate in learning-related services with parental or institutional consent.</p>

      <h2 className="text-xl font-semibold mt-6 mb-2">3. Use of Services</h2>
      <p className="mb-4">You agree not to misuse our services, including but not limited to:</p>
      <ul className="list-disc list-inside ml-4 mb-4">
        <li>Infringing intellectual property</li>
        <li>Violating laws or regulations</li>
        <li>Unauthorized system or data access</li>
        <li>Disrupting our service operations</li>
      </ul>

      <h2 className="text-xl font-semibold mt-6 mb-2">4. Intellectual Property</h2>
      <p className="mb-4">All content created by Racila Softech Pvt. Ltd. remains our property unless otherwise agreed. Unauthorized use or distribution is prohibited.</p>

      <h2 className="text-xl font-semibold mt-6 mb-2">5. Payments and Refunds</h2>
      <p className="mb-4">Payment terms are agreed upon at CRD signing. Refunds follow our <a href="/refund-policy" className="text-blue-600 underline">Refund Policy</a>.</p>

      <h2 className="text-xl font-semibold mt-6 mb-2">6. Data Privacy and Confidentiality</h2>
      <p className="mb-4">We protect client data strictly. All staff, interns, and contractors are bound by confidentiality and NDAs.</p>

      <h2 className="text-xl font-semibold mt-6 mb-2">7. Termination</h2>
      <p className="mb-4">We may suspend/terminate services for Terms violation. Clients may discontinue services per our Refund Policy.</p>

      <h2 className="text-xl font-semibold mt-6 mb-2">8. Third-Party Services</h2>
      <p className="mb-4">We use third-party platforms (e.g., AWS, Google Cloud, payment gateways). We are not liable for issues caused by them.</p>

      <h2 className="text-xl font-semibold mt-6 mb-2">9. Limitation of Liability</h2>
      <p className="mb-4">We are not responsible for indirect or consequential damages from the use of our services.</p>

      <h2 className="text-xl font-semibold mt-6 mb-2">10. Jurisdiction</h2>
      <p className="mb-4">Legal disputes will fall under the jurisdiction of Ujjain and Indore, Madhya Pradesh, India.</p>

      <h2 className="text-xl font-semibold mt-6 mb-2">11. Changes to Terms</h2>
      <p className="mb-4">These Terms may be updated periodically. Continued use means acceptance of changes.</p>

      <h2 className="text-xl font-semibold mt-6 mb-2">12. Contact</h2>
      <p>
        Racila Softech Pvt. Ltd.<br />
        📞 +91 8871787590<br />
        📧 <a href="mailto:support@racilasoftech.com" className="text-blue-600 underline">support@racilasoftech.com</a><br />
        🌐 <a href="https://www.racilaworld.com" target="_blank" rel="noopener noreferrer" className="text-blue-600 underline">www.racilasoftech.in</a>
      </p>
     <footer className="mt-16 border-t border-gray-700 pt-6">
        <div className="container mx-auto text-center text-gray-500">
          <p>&copy; 2025 Racila Softech. All rights reserved.</p>
          <div className="mt-4 flex justify-center space-x-6">
            <button
              onClick={() => window.open("/privacy-policy", "_blank")}
              className="text-sm text-blue-500 hover:text-blue-600 underline"
            >
              Privacy Policy
            </button>
            <button
              onClick={() => window.open("/refund-policy", "_blank")}
              className="text-sm text-blue-500 hover:text-blue-600 underline"
            >
              Refund Policy
            </button>
            <button
              onClick={() => window.open("/terms-and-conditions", "_blank")}
              className="text-sm text-blue-500 hover:text-blue-600 underline"
            >
              Terms & Conditions
            </button>
          </div>
        </div>
      </footer>
    </section>
  );
};

export default TermsAndConditions;
